export const useFeedPostReadIds = async (ids: string[]): Promise<boolean> => {
  try {
    await useApiFetch(URI.FeedReadIds, {
      method: 'POST',
      body: {
        readIds: ids,
      },
    });
    await useFeedLoadFromNetwork();
    return true;
  } catch (e) {
    globalThis.$logger.info('useFeedPostReadIds :: error', e);
    return false;
  }
};
